<template>
  <b-modal
    id="products-modal"
    ref="modal"
    v-model="visible"
    :title="title"
    @hidden="hide"
    @shown="onShow"
    size="lg"
  >
    <ValidationObserver
      ref="prductsForm"
      tag="form"
      @submit.prevent="onSubmit"
      id="prductsForm"
    > 

      <b-form-group
        label-cols-lg="3"
        label="Nazwa:"
        class="required"
        label-for="product_name"
        label-align-lg="right"
      >
        <ValidationProvider name="product_name" rules="required" v-slot="validationContext">
          <b-form-textarea
            id="product_name"
            v-model="product.product_name"
            placeholder="Wprowadź nazwę produktu..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        class="required"
        label-cols-lg="3"
        label="Kategoria:"
        label-for="products_category"
        label-align-lg="right"
      >
        <ValidationProvider name="products_category" rules="required" v-slot="validationContext">
          <multiselect
            id="products_category"
            ref="multi"
            placeholder="Kategoria"
            label="name"
            track-by="value"
            :options="options"
            :close-on-select="true"
            :value="defaultValue"
            @input="onInput"
          >
            <template slot="option" slot-scope="props">
              <span v-html="props.option.html"></span>
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
          </multiselect>
          <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Opis:"
        label-for="product_desc"
        label-align-lg="right"
      >
        <b-form-textarea
          id="product_desc"
          v-model="product.product_desc"
          placeholder="Wprowadź opis produktu..."
          rows="6"
          max-rows="12"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Jednostka:"
        label-for="product_unit"
        label-align-lg="right"
      >
        <ValidationProvider name="product_unit" rules="" v-slot="validationContext">
          <b-form-input id="product_unit" v-model="product.product_unit" placeholder="Wprowadź jednostkę miary..." type="text"></b-form-input>
          <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>


          <div class="d-lg-flex">
            <b-form-group
            label-cols-lg="7"
            label-align-lg="right"
            label="Cena netto:"
            class="required"
            label-for="product_netto"
            >
              <ValidationProvider name="product_netto" rules="required" v-slot="validationContext">
                <b-input-group :append="getMainBaseCurrency">
                  <b-form-input
                    class="col-lg-9"
                    id="product_netto"
                    v-model.number="product.netto"
                    type="text"
                    placeholder="0,00"
                  ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>

            <b-form-group
            label-cols-lg="3"
            label-align-lg="right"
            label="VAT:"
            class="required"
            label-for="product_vat"
            >
              <ValidationProvider name="product_vat" rules="required" v-slot="validationContext">
                <b-input-group append="%">
                  <b-form-input
                    class="col-lg-5"
                    id="product_vat"
                    v-model.number="product.product_vat"
                    type="text"
                    placeholder="0"
                  ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
          </div>


    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button :disabled="isDisabled || isNotChanged || isBusy" size="md" variant="primary" type="submit" form="prductsForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { flatenCategories } from "@/utils/index.js";

export default {
  name: "ModalProducts",
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      product: {
        selected: null
      },

      editedItem: null,
      visible: false,
      isBusy: false,
      search: "",
    };
  },
  computed: {
    ...mapGetters("products", ["root"]),
    ...mapGetters("company", [ "getMainBaseCurrency", "mainCompany"]),
    title() {
      return this.isEdited
        ? "Edytuj prdukt: " + this.editedItem.name
        : "Dodaj nowy produkt";
    },
    defaultValue() {
        return this.options.find((option) => option.value === this.product.selected);
    },
    isEdited() {
      return !!this.editedItem;
    },
    options() {
      const [, ...rest] = flatenCategories(this.root, 0);
      return [...rest];
    },
    isDisabled() {
      const { product_name, netto, selected } = this.product;
      return (
        !product_name ||
        netto === undefined ||
        !selected
      );
    },
    isNotChanged() {
      if (this.isEdited) {
        const { product_name, product_desc, product_unit, netto, product_vat, selected } = this.product;
        const { name, description, unit, netto_amount, vat, category_id } = this.editedItem;
        return (
          product_name === name &&
          product_desc === description &&
          product_unit === unit &&
          netto === netto_amount &&
          product_vat === vat &&
          selected === category_id
        );
      }
      return false;
    }
  },
  methods: {
    ...mapActions("products", ["save"]),
    show(editedItem) {
      this.visible = true;
      this.isBusy = false;
      this.editedItem = editedItem ? { ...editedItem } : null;
      if (editedItem) this.setModalValues();
    },
    hide() {
      this.false = true;
      this.editedItem = null;
      this.product = { selected: null };
    },
    setModalValues() {
      const { name, description, unit, netto_amount, vat, category_id } = this.editedItem;
      
      this.product = {
        selected: category_id,
        product_name: name,
        product_desc: description,
        product_unit: unit,
        product_vat: vat,
        netto: parseFloat(netto_amount).toFixed(2)
      };
    },
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      this.product.product_vat = this.mainCompany.vat_rate;
      if (this.isEdited) {
        this.$refs.multi.value = this.options.find((option) => option.value === this.editedItem.category_id);
      }
    },
    onInput(data) {
      this.product.selected = data.value; 
    },
    onClose() {},
    onSubmit() {
      this.$refs.prductsForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.isBusy = true;
        const { product_name, product_desc, product_unit, netto, product_vat, selected } = this.product;
        this.$Progress.start();
        const bodyFormData = new FormData();
        bodyFormData.set("name", product_name);
        bodyFormData.set("description", product_desc);
        bodyFormData.set("unit", product_unit);
        bodyFormData.set("netto_amount", netto);
        bodyFormData.set("vat_rate", product_vat);
        bodyFormData.set("category_id", selected);
        this.save({
          id: this.isEdited ? this.editedItem.id : null,
          bodyFormData
        }).then(() => {
          this.visible = false;
          this.isBusy = false;
          this.product = { selected: null };
          this.$refs.prductsForm.reset();
        });
      });
    },
  }
};
</script>
